import React from "react";
import { Button } from "../../components/Button/Button";
import { useMutation } from "react-query";
import { AuthService } from "../../services/auth.service";
import { FormikProvider, useFormik } from "formik";
import { Asserts, object, string } from "yup";
import { TextInput } from "../../components/FormInputs/TextInput";
import { AuthActions } from "../../zustand/auth.store";
import { useNavigate } from "react-router-dom";
import { toast } from "react-hot-toast";

export const Login = () => {
  const navigate = useNavigate();
  const validationSchema = object({
    username: string().required().label("Username"),
    password: string().required().label("Password"),
  });
  const form = useFormik<Asserts<typeof validationSchema>>({
    initialValues: {
      username: "",
      password: "",
    },
    validationSchema,
    onSubmit: (values) => {
      submitLogin.mutate(values);
    },
  });

  const submitLogin = useMutation(
    async (values: { username: string; password: string }) => {
      AuthActions.setToken(values);
      return await AuthService.login(values);
    },
    {
      onSuccess: (response) => {
        if (response.data.responseCode === "00") {
          AuthActions.setProfile(response.data.data);
          AuthActions.setRole(response.data.data.roleType);
          toast.success("login successful");
          requestAnimationFrame(() => {
            navigate("/");
          });
        } else if (response.data.responseCode === "03") {
          navigate("/reset-password");
        } else if (response.data.responseCode === "XX") {
          toast.error(response.data.responseMessage);
        }
      },
      onError: (err: any) => {
        if (err.response.data.responseCode === "03") {
          toast.success(err.response.data.responseMessage);
          // console.log("ERROR", err.response);
          navigate("/reset-password");
        } else {
          toast.error(err.response.data.responseMessage);
          // console.log("ERROR", err.response);
        }

      },
    }
  );
  return (
    <div>
      <div className="md:card h-screen md:h-auto w-screen md:w-auto  bg-white rounded-md p-9">
        <div className="flex justify-around">
          <img src={"/images/pc-logo.svg"} className="" alt="Yep_logo" />
        </div>
        <div className="mt-6">
          <h6 className="text-center font-bold">
            Welcome, login to your account
          </h6>
        </div>
        <div>
          <FormikProvider value={form}>
            <form onSubmit={form.handleSubmit}>
              <div className="mt-4 md:w-80">
                <TextInput
                  type="text"
                  label="Enter ID"
                  {...form.getFieldProps("username")}
                  placeholder="Enter your ID"
                  context
                />
              </div>
              <div className="mt-4 ">
                <TextInput
                  type="password"
                  label="Password"
                  {...form.getFieldProps("password")}
                  placeholder="Enter Password"
                  context
                />
              </div>
              <div className="mt-4">
                <Button
                  label="Login"
                  className="justify-center"
                  fullWidth
                  isLoading={submitLogin.isLoading}
                  type="submit"
                  disabled={false}
                />
              </div>
              <div className="mt-6">
                <a onClick={() => navigate("/request-password-reset")} className="hover:underline">
                  <p className="text-sm text-blue-500 text-center">
                    Forgot Password ?
                  </p>
                </a>
              </div>
            </form>
          </FormikProvider>
        </div>
      </div>
    </div>
  );
};
